import { createSlice } from '@reduxjs/toolkit';
import { productsDetailById } from './productsSlice';

const wastageType = ['Damage', 'Return', 'Expiry', 'Entertainment', 'Samples'];
const wastageSubType = {
  Damage: ["Production", "Warehouse", "Delivery"],
  Return: ["Wrong Order", "Production Error", "Customer", "Client"],
  Expiry: ["Warehouse", "Customer", "Client"],
  Entertainment: ["Staff", "Guest", "CEO"],
  Samples: ["Samples"],
};

const wastage = ["Wastage", "Staff", "Guest"];

const initialState = {
  inventory: [],
  wastageType: wastageType,
  wastageSubType: wastageSubType,
  wastage:wastage,
};

const getProductById =(id)=>{
  let product = productsDetailById(id)
  return product

}

export const inventorySlice = createSlice({
  name: 'inventory',
  initialState,
  reducers: {
    setInventory: (state, { payload }) => {
    //  payload = payload.map((item)=>{
    //     let product = productsDetailById(item.id)
    //     console.log(item,product);
    //     return {...item,product}
    //   })
      
      state.inventory = [...payload];
    },
    
   
    clearInventoryState: (state) => {
      state=initialState
    }
  }
});

export const { setInventory, clearInventoryState } = inventorySlice.actions;

export const inventoryData = (state) => state.inventory;

export const getWastageType = (state) => state.inventory.wastageType;

export const getWastageSubType = (state) => state.inventory.wastageSubType;

export const getWastage = (state) => state.inventory.wastage;

export default inventorySlice.reducer;
